import merge from 'lodash.merge';
import {
  GET_SYNERGY_COVERAGE_QUESTIONS_SUCCESS,
  MOBILITY_CONTINUATION_CLEAR,
  MOBILITY_CONTINUATION_GET_SUGGESTIONS,
  MOBILITY_CONTINUATION_SELECT_OPTION,
  MOBILITY_CONTINUATION_SET_PRODUCT_ID,
  MOBILITY_CONTINUATION_SET_CONSENT,
  MOBILITY_CONTINUATION_SET_QUERY_ERROR,
  MOBILITY_CONTINUATION_SET_QUERY_RESULTS_FOR_DESTINATION,
  MOBILITY_CONTINUATION_SET_QUERY_RESULTS_FOR_START,
  SET_SYNERGY_COVERAGE_QUESTION_RESPONSE_SUCCESS,
  SET_SYNERGY_COVERAGE_QUESTION_RESPONSES_SUCCESS,
} from 'redux/actions/types';
import type {
  MobilityContinuationPointsKey,
  MobilityContinuationState,
} from 'ts/types/mobility-continuation.types';

const initialState: MobilityContinuationState = {
  start: {
    loading: false,
    temporalSelected: undefined,
    queryResult: [],
  },
  destination: {
    loading: false,
    temporalSelected: undefined,
    queryResult: [],
  },
  productId: undefined,
  consent: false,
  coverageQuestions: {
    answers: [],
    coverage: [],
    data: undefined,
    wasAnswerRemoved: false,
  },
  services: [],
};

const mobilityContinuationReducer = (state = initialState, action: any) => {
  const baseState = { ...state };
  switch (action.type) {
    case MOBILITY_CONTINUATION_SELECT_OPTION: {
      const currentKey = action.payload.type as MobilityContinuationPointsKey;
      return {
        ...state,
        [currentKey]: {
          ...state[currentKey],
          temporalSelected: action.payload.value,
        },
      };
    }
    case MOBILITY_CONTINUATION_GET_SUGGESTIONS: {
      const currentKey = action.payload.type as MobilityContinuationPointsKey;
      return {
        ...state,
        [currentKey]: {
          ...state[currentKey],
          loading: true,
        },
      };
    }
    case MOBILITY_CONTINUATION_CLEAR: {
      const currentKey = action.payload as MobilityContinuationPointsKey;
      return {
        ...state,
        [currentKey]: {
          ...state[currentKey],
          temporalSelected: undefined,
          queryResult: [],
        },
      };
    }
    case MOBILITY_CONTINUATION_SET_QUERY_RESULTS_FOR_START:
      return {
        ...state,
        start: {
          ...state.start,
          loading: false,
          queryResult: action.payload,
        },
      };
    case MOBILITY_CONTINUATION_SET_QUERY_RESULTS_FOR_DESTINATION:
      return {
        ...state,
        destination: {
          ...state.destination,
          loading: false,
          queryResult: action.payload,
        },
      };
    case MOBILITY_CONTINUATION_SET_QUERY_ERROR:
      return {
        ...state,
        destination: { ...state.destination, loading: false },
        start: { ...state.start, loading: false },
        [action.payload]: {
          ...[action.payload],
          queryResult: [],
        },
      };
    case MOBILITY_CONTINUATION_SET_PRODUCT_ID:
      return {
        ...state,
        productId: action.payload,
      };
    case MOBILITY_CONTINUATION_SET_CONSENT:
      return {
        ...state,
        consent: action.payload,
      };
    case GET_SYNERGY_COVERAGE_QUESTIONS_SUCCESS:
      return {
        ...state,
        coverageQuestions: {
          ...state.coverageQuestions,
          ...action.payload,
        },
      };
    case SET_SYNERGY_COVERAGE_QUESTION_RESPONSES_SUCCESS: {
      return {
        ...state,
        coverageQuestions: {
          ...state.coverageQuestions,
          answers: action.payload,
        },
      };
    }
    /**
     * If user already answered, we must update that answer
     * with its new value
     */
    case SET_SYNERGY_COVERAGE_QUESTION_RESPONSE_SUCCESS: {
      const data = action.payload;
      const currentQuestionIndex =
        baseState.coverageQuestions.answers.findIndex(
          answer => answer.id === data.id,
        );

      if (currentQuestionIndex !== -1) {
        baseState.coverageQuestions.answers[currentQuestionIndex] = data;
        return baseState;
      }

      return merge(baseState, {
        coverageQuestions: {
          answers: [...baseState.coverageQuestions.answers, action.payload],
        },
      });
    }
    default:
      return state;
  }
};

export default mobilityContinuationReducer;
